// src/components/IpfsGatewayLoader.tsx
import { useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import { setIpfsGatewayUrl } from "../utils/ipfsConfig";

const GET_TENANT_IPFS_CONFIG = gql`
  query GetTenantIpfsConfig {
    currentTenant {
      id
      apiKeys {
        ipfsGatewayUrl
      }
    }
  }
`;

export const IpfsGatewayLoader = ({ children }: { children: React.ReactNode }) => {
  const { data } = useQuery(GET_TENANT_IPFS_CONFIG, {
    fetchPolicy: "cache-first",
  });

  useEffect(() => {
    const url = data?.currentTenant?.apiKeys?.ipfsGatewayUrl;
    if (url) {
      setIpfsGatewayUrl(url);
    }
  }, [data]);

  return <>{children}</>;
};
